(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apex-complete-terms-of-service"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setPanelState(item, open) {
      const trigger = item.querySelector('[data-atc-trigger]');
      const panel = item.querySelector('[data-atc-panel]');

      if (!trigger || !panel) return;

      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }

    function initAccordion(section) {
      if (!section || section.dataset.apexTermsCompleteInitialized === 'true') return;

      section.dataset.apexTermsCompleteInitialized = 'true';

      const singleOpen = section.dataset.singleOpen === 'true';
      const items = Array.from(section.querySelectorAll('[data-atc-item]'));

      items.forEach(function (item) {
        const trigger = item.querySelector('[data-atc-trigger]');

        if (!trigger) return;

        trigger.addEventListener('click', function () {
          const willOpen = trigger.getAttribute('aria-expanded') !== 'true';

          if (singleOpen && willOpen) {
            items.forEach(function (otherItem) {
              if (otherItem !== item) setPanelState(otherItem, false);
            });
          }

          setPanelState(item, willOpen);
        });
      });

      const revealElements = section.querySelectorAll(
        '.atc-header, .atc-overview, .atc-item, .atc-footer-note'
      );

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        revealElements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.08,
          rootMargin: '0px 0px -40px 0px'
        }
      );

      revealElements.forEach(function (element, index) {
        element.style.setProperty('--atc-delay', Math.min(index * 55, 350) + 'ms');
        observer.observe(element);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-apex-terms-complete]').forEach(function (section) {
        section.dataset.singleOpen = section.getAttribute('data-single-open') || 'false';
        initAccordion(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-terms-complete]')
        ? event.target
        : event.target.querySelector('[data-apex-terms-complete]');

      if (section) initAccordion(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-contact-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const contactFormSection = document.querySelector('[data-apex-contact-form]');

  if (!contactFormSection) return;

  const contactFormTarget = document.getElementById('ApexContactForm');

  document.querySelectorAll('a[href="#ApexContactForm"]').forEach((link) => {
    link.addEventListener('click', function (event) {
      if (!contactFormTarget) return;

      event.preventDefault();

      contactFormTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      window.setTimeout(() => {
        const firstInput = contactFormTarget.querySelector(
          'input:not([type="hidden"]), select, textarea'
        );

        if (firstInput) {
          firstInput.focus({
            preventScroll: true
          });
        }
      }, 650);
    });
  });

  const form = contactFormSection.querySelector('form');

  if (!form) return;

  const submitButton = form.querySelector('.acf-button');

  form.addEventListener('submit', function () {
    if (!submitButton) return;

    submitButton.classList.add('is-loading');
    submitButton.setAttribute('aria-busy', 'true');
    submitButton.disabled = true;

    const buttonText = submitButton.querySelector('span');

    if (buttonText) {
      buttonText.textContent = 'Sending...';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-contact-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-apex-contact-hero]');

  if (!sections.length) return;

  sections.forEach((section) => {
    const revealItems = section.querySelectorAll(
      '.apex-contact-hero__reveal'
    );

    const prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    revealItems.forEach((item) => observer.observe(item));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-contact-support-options"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-apex-contact-options]');

  if (!sections.length) return;

  sections.forEach((section) => {
    const items = section.querySelectorAll(
      '.apex-contact-options__reveal'
    );

    const reducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -10% 0px'
      }
    );

    items.forEach((item) => observer.observe(item));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-customer-stories"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-apex-customer-stories]');

  if (!sections.length) return;

  sections.forEach((section) => {
    const revealItems = section.querySelectorAll(
      '.apex-customer-stories__reveal'
    );

    const prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => {
        item.classList.add('is-visible');
      });

      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    revealItems.forEach((item) => {
      observer.observe(item);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-designed-for-evening"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-apex-designed-evening]');

  if (!sections.length) return;

  sections.forEach((section) => {
    const revealItems = section.querySelectorAll(
      '.apex-designed-evening__reveal'
    );

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    if (!('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    revealItems.forEach((item) => observer.observe(item));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-designed-for-life"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDesignedForLife(section) {
      if (!section || section.dataset.apexDesignedForLifeInitialized === 'true') return;

      section.dataset.apexDesignedForLifeInitialized = 'true';

      const elements = section.querySelectorAll(
        '.adfl-copy, .adfl-media, .adfl-moment, .adfl-closing'
      );

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.08,
          rootMargin: '0px 0px -35px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty('--adfl-delay', Math.min(index * 70, 340) + 'ms');
        observer.observe(element);
      });
    }

    function initAllDesignedForLife() {
      document
        .querySelectorAll('[data-apex-designed-for-life]')
        .forEach(initDesignedForLife);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllDesignedForLife);
    } else {
      initAllDesignedForLife();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-designed-for-life]')
        ? event.target
        : event.target.querySelector('[data-apex-designed-for-life]');

      if (section) initDesignedForLife(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-difference"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initApexDifference(section) {
      if (!section || section.dataset.apexDifferenceInitialized === 'true') return;

      section.dataset.apexDifferenceInitialized = 'true';

      const elements = section.querySelectorAll(
        '.adf-header, .adf-media, .adf-feature, .adf-comparison, .adf-closing'
      );

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.08,
          rootMargin: '0px 0px -35px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty('--adf-delay', Math.min(index * 65, 340) + 'ms');
        observer.observe(element);
      });
    }

    function initAllApexDifference() {
      document
        .querySelectorAll('[data-apex-difference]')
        .forEach(initApexDifference);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllApexDifference);
    } else {
      initAllApexDifference();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-difference]')
        ? event.target
        : event.target.querySelector('[data-apex-difference]');

      if (section) initApexDifference(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initializeApexFAQ(section) {
    if (!section || section.dataset.apexFaqInitialized === 'true') return;

    section.dataset.apexFaqInitialized = 'true';

    const categoryButtons = Array.from(
      section.querySelectorAll('[data-faq-category-button]')
    );

    const faqItems = Array.from(
      section.querySelectorAll('[data-faq-item]')
    );

    if (!faqItems.length) return;

    function closeItem(item, immediate) {
      const button = item.querySelector('.afa-question');
      const answer = item.querySelector('.afa-answer');

      if (!button || !answer || !item.classList.contains('is-open')) return;

      button.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-open');

      if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        answer.style.height = '0px';
        answer.hidden = true;
        return;
      }

      answer.style.height = answer.scrollHeight + 'px';

      window.requestAnimationFrame(function () {
        answer.style.height = '0px';
      });

      const onCloseEnd = function (event) {
        if (event.propertyName !== 'height') return;

        answer.hidden = true;
        answer.removeEventListener('transitionend', onCloseEnd);
      };

      answer.addEventListener('transitionend', onCloseEnd);
    }

    function openItem(item) {
      const button = item.querySelector('.afa-question');
      const answer = item.querySelector('.afa-answer');

      if (!button || !answer || item.classList.contains('is-open')) return;

      faqItems.forEach(function (otherItem) {
        if (otherItem !== item) {
          closeItem(otherItem, false);
        }
      });

      answer.hidden = false;
      answer.style.height = '0px';

      button.setAttribute('aria-expanded', 'true');
      item.classList.add('is-open');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        answer.style.height = 'auto';
        return;
      }

      window.requestAnimationFrame(function () {
        answer.style.height = answer.scrollHeight + 'px';
      });

      const onOpenEnd = function (event) {
        if (event.propertyName !== 'height') return;

        if (item.classList.contains('is-open')) {
          answer.style.height = 'auto';
        }

        answer.removeEventListener('transitionend', onOpenEnd);
      };

      answer.addEventListener('transitionend', onOpenEnd);
    }

    function toggleItem(item) {
      if (item.classList.contains('is-open')) {
        closeItem(item, false);
      } else {
        openItem(item);
      }
    }

    function filterCategory(category) {
      categoryButtons.forEach(function (button) {
        const isActive =
          button.dataset.faqCategoryButton === category;

        button.classList.toggle('is-active', isActive);
        button.setAttribute(
          'aria-pressed',
          isActive ? 'true' : 'false'
        );
      });

      faqItems.forEach(function (item) {
        const matches =
          item.dataset.faqCategory === category;

        if (!matches) {
          closeItem(item, true);
        }

        item.classList.toggle('is-hidden', !matches);
        item.setAttribute(
          'aria-hidden',
          matches ? 'false' : 'true'
        );
      });

      const firstVisibleItem = faqItems.find(function (item) {
        return !item.classList.contains('is-hidden');
      });

      if (firstVisibleItem) {
        openItem(firstVisibleItem);
      }
    }

    faqItems.forEach(function (item) {
      const questionButton = item.querySelector('.afa-question');

      if (!questionButton) return;

      questionButton.addEventListener('click', function () {
        toggleItem(item);
      });
    });

    categoryButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        filterCategory(button.dataset.faqCategoryButton);

      });
    });

    const activeCategoryButton =
      section.querySelector(
        '[data-faq-category-button].is-active'
      ) || categoryButtons[0];

    if (activeCategoryButton) {
      filterCategory(
        activeCategoryButton.dataset.faqCategoryButton
      );
    } else {
      openItem(faqItems[0]);
    }

    window.addEventListener('resize', function () {
      const openAnswer = section.querySelector(
        '.afa-item.is-open .afa-answer'
      );

      if (openAnswer && openAnswer.style.height !== 'auto') {
        openAnswer.style.height =
          openAnswer.scrollHeight + 'px';
      }
    });
  }

  function initializeAllApexFAQs() {
    document
      .querySelectorAll('[data-apex-faq]')
      .forEach(initializeApexFAQ);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllApexFAQs
    );
  } else {
    initializeAllApexFAQs();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      const faqSection = event.target.querySelector(
        '[data-apex-faq]'
      );

      if (faqSection) {
        initializeApexFAQ(faqSection);
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-faq-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const faqHero = document.querySelector('.apex-faq-hero');

  if (!faqHero) return;

  const faqButton = faqHero.querySelector('a[href="#ApexFAQAccordion"]');
  const faqTarget = document.getElementById('ApexFAQAccordion');

  if (!faqButton || !faqTarget) return;

  faqButton.addEventListener('click', function (event) {
    event.preventDefault();

    faqTarget.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-faq-support-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initializeApexFAQSupport(section) {
    if (!section || section.dataset.apexFaqSupportInitialized === 'true') return;

    section.dataset.apexFaqSupportInitialized = 'true';

    const revealElements = section.querySelectorAll(
      '.afc-content, .afc-image-wrap'
    );

    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      revealElements.forEach(function (element) {
        element.classList.add('is-visible');
      });

      return;
    }

    const observer = new IntersectionObserver(
      function (entries, currentObserver) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.18,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    revealElements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function initializeAllApexFAQSupportSections() {
    document
      .querySelectorAll('[data-apex-faq-support]')
      .forEach(initializeApexFAQSupport);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllApexFAQSupportSections
    );
  } else {
    initializeAllApexFAQSupportSections();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      const section = event.target.querySelector(
        '[data-apex-faq-support]'
      );

      if (section) {
        initializeApexFAQSupport(section);
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-final-cta"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-apex-final-cta]');

  if (!sections.length) return;

  sections.forEach((section) => {
    const revealItems = section.querySelectorAll(
      '.apex-final-cta__reveal'
    );

    const prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => {
        item.classList.add('is-visible');
      });

      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.16,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    revealItems.forEach((item) => {
      observer.observe(item);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-final-editorial-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFinalCta(section) {
      if (!section || section.dataset.apexFinalCtaInitialized === 'true') return;

      section.dataset.apexFinalCtaInitialized = 'true';

      const elements = section.querySelectorAll('.afc-content, .afc-trust');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -40px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty('--afc-delay', (index * 120) + 'ms');
        observer.observe(element);
      });
    }

    function initAllFinalCtas() {
      document
        .querySelectorAll('[data-apex-final-cta]')
        .forEach(initFinalCta);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllFinalCtas);
    } else {
      initAllFinalCtas();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-final-cta]')
        ? event.target
        : event.target.querySelector('[data-apex-final-cta]');

      if (section) initFinalCta(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-our-commitment"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCommitment(section) {
      if (!section || section.dataset.apexCommitmentInitialized === 'true') return;

      section.dataset.apexCommitmentInitialized = 'true';

      const elements = section.querySelectorAll(
        '.aoc-header, .aoc-card, .aoc-statement'
      );

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.08,
          rootMargin: '0px 0px -35px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty('--aoc-delay', Math.min(index * 70, 340) + 'ms');
        observer.observe(element);
      });
    }

    function initAllCommitment() {
      document
        .querySelectorAll('[data-apex-commitment]')
        .forEach(initCommitment);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllCommitment);
    } else {
      initAllCommitment();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-commitment]')
        ? event.target
        : event.target.querySelector('[data-apex-commitment]');

      if (section) initCommitment(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-our-philosophy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPhilosophyV2(section) {
      if (!section || section.dataset.apexPhilosophyV2Initialized === 'true') return;

      section.dataset.apexPhilosophyV2Initialized = 'true';

      const elements = section.querySelectorAll(
        '.aop2-header, .aop2-featured, .aop2-principle, .aop2-manifesto'
      );

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.08,
          rootMargin: '0px 0px -35px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty('--aop2-delay', Math.min(index * 65, 320) + 'ms');
        observer.observe(element);
      });
    }

    function initAllPhilosophyV2() {
      document
        .querySelectorAll('[data-apex-philosophy-v2]')
        .forEach(initPhilosophyV2);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllPhilosophyV2);
    } else {
      initAllPhilosophyV2();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-philosophy-v2]')
        ? event.target
        : event.target.querySelector('[data-apex-philosophy-v2]');

      if (section) initPhilosophyV2(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-privacy-children-policy-updates"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initApexPrivacyChildrenUpdates(section) {
      if (!section || section.dataset.apexPrivacyChildrenUpdatesInitialized === 'true') return;

      section.dataset.apexPrivacyChildrenUpdatesInitialized = 'true';

      const elements = section.querySelectorAll(
        '.apcu-header, .apcu-feature-card, .apcu-detail-card, .apcu-notice-panel, .apcu-note'
      );

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty(
          '--apcu-delay',
          Math.min(index * 80, 400) + 'ms'
        );
        observer.observe(element);
      });
    }

    function initAllApexPrivacyChildrenUpdates() {
      document
        .querySelectorAll('[data-apex-privacy-children-updates]')
        .forEach(initApexPrivacyChildrenUpdates);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllApexPrivacyChildrenUpdates);
    } else {
      initAllApexPrivacyChildrenUpdates();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-privacy-children-updates]')
        ? event.target
        : event.target.querySelector('[data-apex-privacy-children-updates]');

      if (section) initApexPrivacyChildrenUpdates(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-privacy-contact-final-notice"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initApexPrivacyContact(section) {
      if (!section || section.dataset.apexPrivacyContactInitialized === 'true') return;

      section.dataset.apexPrivacyContactInitialized = 'true';

      const elements = section.querySelectorAll(
        '.apc-header, .apc-contact-card, .apc-final-panel, .apc-response-panel, .apc-legal-note'
      );

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty(
          '--apc-delay',
          Math.min(index * 80, 400) + 'ms'
        );
        observer.observe(element);
      });
    }

    function initAllApexPrivacyContact() {
      document
        .querySelectorAll('[data-apex-privacy-contact]')
        .forEach(initApexPrivacyContact);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllApexPrivacyContact);
    } else {
      initAllApexPrivacyContact();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-privacy-contact]')
        ? event.target
        : event.target.querySelector('[data-apex-privacy-contact]');

      if (section) initApexPrivacyContact(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-privacy-cookies-analytics"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initApexPrivacyCookies(section) {
      if (!section || section.dataset.apexPrivacyCookiesInitialized === 'true') return;

      section.dataset.apexPrivacyCookiesInitialized = 'true';

      const elements = section.querySelectorAll(
        '.apc-header, .apc-summary, .apc-card, .apc-control-panel, .apc-note'
      );

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty(
          '--apc-delay',
          Math.min(index * 80, 400) + 'ms'
        );
        observer.observe(element);
      });
    }

    function initAllApexPrivacyCookies() {
      document
        .querySelectorAll('[data-apex-privacy-cookies]')
        .forEach(initApexPrivacyCookies);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllApexPrivacyCookies);
    } else {
      initAllApexPrivacyCookies();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-privacy-cookies]')
        ? event.target
        : event.target.querySelector('[data-apex-privacy-cookies]');

      if (section) initApexPrivacyCookies(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-privacy-data-security"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initApexPrivacySecurity(section) {
      if (!section || section.dataset.apexPrivacySecurityInitialized === 'true') return;

      section.dataset.apexPrivacySecurityInitialized = 'true';

      const elements = section.querySelectorAll(
        '.apds-header, .apds-summary, .apds-card, .apds-incident-panel, .apds-note'
      );

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty(
          '--apds-delay',
          Math.min(index * 80, 400) + 'ms'
        );
        observer.observe(element);
      });
    }

    function initAllApexPrivacySecurity() {
      document
        .querySelectorAll('[data-apex-privacy-security]')
        .forEach(initApexPrivacySecurity);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllApexPrivacySecurity);
    } else {
      initAllApexPrivacySecurity();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-privacy-security]')
        ? event.target
        : event.target.querySelector('[data-apex-privacy-security]');

      if (section) initApexPrivacySecurity(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-privacy-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeApexPrivacyHero(section) {
      if (
        !section ||
        section.dataset.apexPrivacyHeroInitialized === 'true'
      ) {
        return;
      }

      section.dataset.apexPrivacyHeroInitialized = 'true';

      const revealElements = section.querySelectorAll(
        '.aph-content, .aph-visual'
      );

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (
        prefersReducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        revealElements.forEach(function (element) {
          element.classList.add('is-visible');
        });

        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      revealElements.forEach(function (element, index) {
        element.style.setProperty(
          '--aph-reveal-delay',
          index * 140 + 'ms'
        );

        observer.observe(element);
      });
    }

    function initializeAllApexPrivacyHeroes() {
      document
        .querySelectorAll('[data-apex-privacy-hero]')
        .forEach(initializeApexPrivacyHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeAllApexPrivacyHeroes
      );
    } else {
      initializeAllApexPrivacyHeroes();
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        const section = event.target.matches(
          '[data-apex-privacy-hero]'
        )
          ? event.target
          : event.target.querySelector(
              '[data-apex-privacy-hero]'
            );

        if (section) {
          initializeApexPrivacyHero(section);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-privacy-how-we-use-information"] && !Shopify.designMode) return;
  try {
    
(function(){function init(section){if(!section||section.dataset.apexPrivacyUseInitialized==='true')return;section.dataset.apexPrivacyUseInitialized='true';var items=section.querySelectorAll('.apu-reveal');var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;if(reduced||!('IntersectionObserver'in window)){items.forEach(function(el){el.classList.add('is-visible')});return}var observer=new IntersectionObserver(function(entries,o){entries.forEach(function(entry){if(!entry.isIntersecting)return;entry.target.classList.add('is-visible');o.unobserve(entry.target)})},{threshold:.1,rootMargin:'0px 0px -45px 0px'});items.forEach(function(el,index){el.style.setProperty('--apu-delay',Math.min(index*80,400)+'ms');observer.observe(el)})}function initAll(){document.querySelectorAll('[data-apex-privacy-use]').forEach(init)}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAll)}else{initAll()}document.addEventListener('shopify:section:load',function(event){var section=event.target.matches('[data-apex-privacy-use]')?event.target:event.target.querySelector('[data-apex-privacy-use]');if(section)init(section)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-privacy-information-sharing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initApexPrivacySharing(section) {
      if (!section || section.dataset.apexPrivacySharingInitialized === 'true') return;

      section.dataset.apexPrivacySharingInitialized = 'true';

      const elements = section.querySelectorAll(
        '.aps-header, .aps-card, .aps-principles, .aps-note'
      );

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty(
          '--aps-delay',
          Math.min(index * 80, 400) + 'ms'
        );
        observer.observe(element);
      });
    }

    function initAllApexPrivacySharing() {
      document
        .querySelectorAll('[data-apex-privacy-sharing]')
        .forEach(initApexPrivacySharing);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllApexPrivacySharing);
    } else {
      initAllApexPrivacySharing();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-privacy-sharing]')
        ? event.target
        : event.target.querySelector('[data-apex-privacy-sharing]');

      if (section) initApexPrivacySharing(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-privacy-information"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeApexPrivacyInformation(section) {
      if (
        !section ||
        section.dataset.apexPrivacyInformationInitialized === 'true'
      ) {
        return;
      }

      section.dataset.apexPrivacyInformationInitialized = 'true';

      const revealElements = section.querySelectorAll(
        '.api-header, .api-summary, .api-card, .api-automatic-panel, .api-footer-note'
      );

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (
        prefersReducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        revealElements.forEach(function (element) {
          element.classList.add('is-visible');
        });

        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      revealElements.forEach(function (element, index) {
        element.style.setProperty(
          '--api-delay',
          Math.min(index * 80, 400) + 'ms'
        );

        observer.observe(element);
      });
    }

    function initializeAllApexPrivacyInformationSections() {
      document
        .querySelectorAll('[data-apex-privacy-information]')
        .forEach(initializeApexPrivacyInformation);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeAllApexPrivacyInformationSections
      );
    } else {
      initializeAllApexPrivacyInformationSections();
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        const section = event.target.matches(
          '[data-apex-privacy-information]'
        )
          ? event.target
          : event.target.querySelector(
              '[data-apex-privacy-information]'
            );

        if (section) {
          initializeApexPrivacyInformation(section);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-privacy-retention-international-transfers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initApexPrivacyRetention(section) {
      if (!section || section.dataset.apexPrivacyRetentionInitialized === 'true') return;

      section.dataset.apexPrivacyRetentionInitialized = 'true';

      const elements = section.querySelectorAll(
        '.aprt-header, .aprt-card, .aprt-transfer-panel, .aprt-note'
      );

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty(
          '--aprt-delay',
          Math.min(index * 80, 400) + 'ms'
        );
        observer.observe(element);
      });
    }

    function initAllApexPrivacyRetention() {
      document
        .querySelectorAll('[data-apex-privacy-retention]')
        .forEach(initApexPrivacyRetention);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllApexPrivacyRetention);
    } else {
      initAllApexPrivacyRetention();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-privacy-retention]')
        ? event.target
        : event.target.querySelector('[data-apex-privacy-retention]');

      if (section) initApexPrivacyRetention(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-privacy-rights"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initApexPrivacyRights(section) {
      if (!section || section.dataset.apexPrivacyRightsInitialized === 'true') return;

      section.dataset.apexPrivacyRightsInitialized = 'true';

      const elements = section.querySelectorAll(
        '.apr-header, .apr-summary, .apr-card, .apr-request-panel, .apr-note'
      );

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty(
          '--apr-delay',
          Math.min(index * 80, 400) + 'ms'
        );
        observer.observe(element);
      });
    }

    function initAllApexPrivacyRights() {
      document
        .querySelectorAll('[data-apex-privacy-rights]')
        .forEach(initApexPrivacyRights);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllApexPrivacyRights);
    } else {
      initAllApexPrivacyRights();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-privacy-rights]')
        ? event.target
        : event.target.querySelector('[data-apex-privacy-rights]');

      if (section) initApexPrivacyRights(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-refund-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeApexRefundDetails(section) {
      if (
        !section ||
        section.dataset.apexRefundDetailsInitialized === 'true'
      ) {
        return;
      }

      section.dataset.apexRefundDetailsInitialized = 'true';

      const revealElements = section.querySelectorAll(
        '.ard-header, .ard-detail-card, .ard-summary-panel, .ard-highlight, .ard-bank-notice'
      );

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (
        prefersReducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        revealElements.forEach(function (element) {
          element.classList.add('is-visible');
        });

        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      revealElements.forEach(function (element, index) {
        element.style.setProperty(
          '--ard-reveal-delay',
          Math.min(index * 85, 600) + 'ms'
        );

        observer.observe(element);
      });
    }

    function initializeAllApexRefundDetailsSections() {
      document
        .querySelectorAll('[data-apex-refund-details]')
        .forEach(initializeApexRefundDetails);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeAllApexRefundDetailsSections
      );
    } else {
      initializeAllApexRefundDetailsSections();
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        const section = event.target.matches(
          '[data-apex-refund-details]'
        )
          ? event.target
          : event.target.querySelector(
              '[data-apex-refund-details]'
            );

        if (section) {
          initializeApexRefundDetails(section);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-refund-eligibility"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeApexRefundEligibility(section) {
      if (
        !section ||
        section.dataset.apexRefundEligibilityInitialized === 'true'
      ) {
        return;
      }

      section.dataset.apexRefundEligibilityInitialized = 'true';

      const revealElements = section.querySelectorAll(
        '.are-header, .are-featured-notice, .are-card, .are-bottom-note'
      );

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (
        prefersReducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        revealElements.forEach(function (element) {
          element.classList.add('is-visible');
        });

        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      revealElements.forEach(function (element, index) {
        element.style.setProperty(
          '--are-reveal-delay',
          Math.min(index * 80, 520) + 'ms'
        );

        observer.observe(element);
      });
    }

    function initializeAllApexRefundEligibilitySections() {
      document
        .querySelectorAll('[data-apex-refund-eligibility]')
        .forEach(initializeApexRefundEligibility);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeAllApexRefundEligibilitySections
      );
    } else {
      initializeAllApexRefundEligibilitySections();
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        const section = event.target.matches(
          '[data-apex-refund-eligibility]'
        )
          ? event.target
          : event.target.querySelector(
              '[data-apex-refund-eligibility]'
            );

        if (section) {
          initializeApexRefundEligibility(section);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-refund-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeApexRefundHero(section) {
      if (
        !section ||
        section.dataset.apexRefundHeroInitialized === 'true'
      ) {
        return;
      }

      section.dataset.apexRefundHeroInitialized = 'true';

      const revealElements = section.querySelectorAll(
        '.arh-content, .arh-visual'
      );

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (
        prefersReducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        revealElements.forEach(function (element) {
          element.classList.add('is-visible');
        });

        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      revealElements.forEach(function (element, index) {
        element.style.setProperty(
          '--arh-reveal-delay',
          index * 140 + 'ms'
        );

        observer.observe(element);
      });
    }

    function initializeAllApexRefundHeroes() {
      document
        .querySelectorAll('[data-apex-refund-hero]')
        .forEach(initializeApexRefundHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeAllApexRefundHeroes
      );
    } else {
      initializeAllApexRefundHeroes();
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        const section = event.target.matches(
          '[data-apex-refund-hero]'
        )
          ? event.target
          : event.target.querySelector(
              '[data-apex-refund-hero]'
            );

        if (section) {
          initializeApexRefundHero(section);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-refund-support-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeApexRefundSupportCta(section) {
      if (
        !section ||
        section.dataset.apexRefundSupportCtaInitialized === 'true'
      ) {
        return;
      }

      section.dataset.apexRefundSupportCtaInitialized = 'true';

      const revealElements = section.querySelectorAll(
        '.arsc-content, .arsc-support-card, .arsc-bottom-bar'
      );

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (
        prefersReducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        revealElements.forEach(function (element) {
          element.classList.add('is-visible');
        });

        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      revealElements.forEach(function (element, index) {
        element.style.setProperty(
          '--arsc-reveal-delay',
          index * 130 + 'ms'
        );

        observer.observe(element);
      });
    }

    function initializeAllApexRefundSupportCtas() {
      document
        .querySelectorAll('[data-apex-refund-support-cta]')
        .forEach(initializeApexRefundSupportCta);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeAllApexRefundSupportCtas
      );
    } else {
      initializeAllApexRefundSupportCtas();
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        const section = event.target.matches(
          '[data-apex-refund-support-cta]'
        )
          ? event.target
          : event.target.querySelector(
              '[data-apex-refund-support-cta]'
            );

        if (section) {
          initializeApexRefundSupportCta(section);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-return-process"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeApexReturnProcess(section) {
      if (
        !section ||
        section.dataset.apexReturnProcessInitialized === 'true'
      ) {
        return;
      }

      section.dataset.apexReturnProcessInitialized = 'true';

      const process = section.querySelector('.arp-process');

      const revealElements = section.querySelectorAll(
        '.arp-header, .arp-step, .arp-featured-card, .arp-shipping-notice'
      );

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (
        prefersReducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        revealElements.forEach(function (element) {
          element.classList.add('is-visible');
        });

        if (process) {
          process.classList.add('is-visible');
        }

        return;
      }

      const revealObserver = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      revealElements.forEach(function (element, index) {
        element.style.setProperty(
          '--arp-reveal-delay',
          Math.min(index * 85, 600) + 'ms'
        );

        revealObserver.observe(element);
      });

      if (process) {
        const processObserver = new IntersectionObserver(
          function (entries, currentObserver) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) {
                return;
              }

              process.classList.add('is-visible');
              currentObserver.unobserve(entry.target);
            });
          },
          {
            threshold: 0.08,
            rootMargin: '0px 0px -60px 0px'
          }
        );

        processObserver.observe(process);
      }
    }

    function initializeAllApexReturnProcessSections() {
      document
        .querySelectorAll('[data-apex-return-process]')
        .forEach(initializeApexReturnProcess);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeAllApexReturnProcessSections
      );
    } else {
      initializeAllApexReturnProcessSections();
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        const section = event.target.matches(
          '[data-apex-return-process]'
        )
          ? event.target
          : event.target.querySelector(
              '[data-apex-return-process]'
            );

        if (section) {
          initializeApexReturnProcess(section);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-science-benefits-routine-safety"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBenefitsSafety(section) {
      if (!section || section.dataset.apexScienceBenefitsInitialized === 'true') return;

      section.dataset.apexScienceBenefitsInitialized = 'true';

      const elements = section.querySelectorAll(
        '.asbs-header, .asbs-benefit-card, .asbs-routine-card, .asbs-safety-card, .asbs-expectations, .asbs-disclaimer'
      );

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.09,
          rootMargin: '0px 0px -40px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty('--asbs-delay', Math.min(index * 70, 360) + 'ms');
        observer.observe(element);
      });
    }

    function initAllBenefitsSafety() {
      document
        .querySelectorAll('[data-apex-science-benefits-safety]')
        .forEach(initBenefitsSafety);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllBenefitsSafety);
    } else {
      initAllBenefitsSafety();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-science-benefits-safety]')
        ? event.target
        : event.target.querySelector('[data-apex-science-benefits-safety]');

      if (section) initBenefitsSafety(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-science-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setPanelState(item, open, animate) {
      const trigger = item.querySelector('[data-accordion-trigger]');
      const panel = item.querySelector('[data-accordion-panel]');

      if (!trigger || !panel) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const shouldAnimate = animate && !reducedMotion;

      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      item.classList.toggle('is-open', open);

      if (open) {
        panel.hidden = false;

        if (!shouldAnimate) {
          panel.style.height = 'auto';
          return;
        }

        panel.style.height = '0px';

        requestAnimationFrame(function () {
          panel.style.height = panel.scrollHeight + 'px';
        });

        const onOpenEnd = function (event) {
          if (event.propertyName !== 'height') return;
          panel.style.height = 'auto';
          panel.removeEventListener('transitionend', onOpenEnd);
        };

        panel.addEventListener('transitionend', onOpenEnd);
      } else {
        if (!shouldAnimate) {
          panel.style.height = '0px';
          panel.hidden = true;
          return;
        }

        panel.style.height = panel.scrollHeight + 'px';

        requestAnimationFrame(function () {
          panel.style.height = '0px';
        });

        const onCloseEnd = function (event) {
          if (event.propertyName !== 'height') return;
          panel.hidden = true;
          panel.removeEventListener('transitionend', onCloseEnd);
        };

        panel.addEventListener('transitionend', onCloseEnd);
      }
    }

    function initAccordion(section) {
      if (!section || section.dataset.apexScienceFaqInitialized === 'true') return;

      section.dataset.apexScienceFaqInitialized = 'true';

      const accordion = section.querySelector('[data-accordion]');
      const items = Array.from(section.querySelectorAll('[data-accordion-item]'));
      const allowMultiple = accordion && accordion.dataset.allowMultiple === 'true';

      items.forEach(function (item) {
        const trigger = item.querySelector('[data-accordion-trigger]');
        const isOpen = item.classList.contains('is-open');

        setPanelState(item, isOpen, false);

        if (!trigger) return;

        trigger.addEventListener('click', function () {
          const currentlyOpen = trigger.getAttribute('aria-expanded') === 'true';

          if (!allowMultiple && !currentlyOpen) {
            items.forEach(function (otherItem) {
              if (otherItem !== item && otherItem.classList.contains('is-open')) {
                setPanelState(otherItem, false, true);
              }
            });
          }

          setPanelState(item, !currentlyOpen, true);
        });

        trigger.addEventListener('keydown', function (event) {
          const triggers = items
            .map(function (currentItem) {
              return currentItem.querySelector('[data-accordion-trigger]');
            })
            .filter(Boolean);

          const currentIndex = triggers.indexOf(trigger);
          let nextIndex = null;

          if (event.key === 'ArrowDown') {
            nextIndex = (currentIndex + 1) % triggers.length;
          } else if (event.key === 'ArrowUp') {
            nextIndex = (currentIndex - 1 + triggers.length) % triggers.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = triggers.length - 1;
          }

          if (nextIndex !== null) {
            event.preventDefault();
            triggers[nextIndex].focus();
          }
        });
      });

      const revealElements = section.querySelectorAll('.asf-header, .asf-item, .asf-support');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        revealElements.forEach(function (element) {
          element.classList.add('is-visible');
        });
      } else {
        const observer = new IntersectionObserver(
          function (entries, currentObserver) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              currentObserver.unobserve(entry.target);
            });
          },
          {
            threshold: 0.08,
            rootMargin: '0px 0px -35px 0px'
          }
        );

        revealElements.forEach(function (element, index) {
          element.style.setProperty('--asf-delay', Math.min(index * 65, 360) + 'ms');
          observer.observe(element);
        });
      }
    }

    function initAllAccordions() {
      document
        .querySelectorAll('[data-apex-science-faq]')
        .forEach(initAccordion);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllAccordions);
    } else {
      initAllAccordions();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-science-faq]')
        ? event.target
        : event.target.querySelector('[data-apex-science-faq]');

      if (section) initAccordion(section);
    });

    document.addEventListener('shopify:block:select', function (event) {
      const item = event.target.closest('[data-accordion-item]');
      if (!item) return;

      const section = item.closest('[data-apex-science-faq]');
      if (!section) return;

      const allowMultiple =
        section.querySelector('[data-accordion]')?.dataset.allowMultiple === 'true';

      if (!allowMultiple) {
        section.querySelectorAll('[data-accordion-item].is-open').forEach(function (openItem) {
          if (openItem !== item) setPanelState(openItem, false, false);
        });
      }

      setPanelState(item, true, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-science-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initScienceHero(section) {
      if (!section || section.dataset.apexScienceHeroInitialized === 'true') return;

      section.dataset.apexScienceHeroInitialized = 'true';

      const elements = section.querySelectorAll('.ash-copy, .ash-panel');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.14,
          rootMargin: '0px 0px -40px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty('--ash-delay', (index * 130) + 'ms');
        observer.observe(element);
      });
    }

    function initAllScienceHeroes() {
      document
        .querySelectorAll('[data-apex-science-hero]')
        .forEach(initScienceHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllScienceHeroes);
    } else {
      initAllScienceHeroes();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-science-hero]')
        ? event.target
        : event.target.querySelector('[data-apex-science-hero]');

      if (section) initScienceHero(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-science-how-light-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initScienceHowItWorks(section) {
      if (!section || section.dataset.apexScienceHowInitialized === 'true') return;

      section.dataset.apexScienceHowInitialized = 'true';

      const elements = section.querySelectorAll(
        '.ashi-header, .ashi-spectrum, .ashi-light-card, .ashi-process, .ashi-wavelength-note, .ashi-disclaimer'
      );

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.09,
          rootMargin: '0px 0px -40px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty('--ashi-delay', Math.min(index * 75, 380) + 'ms');
        observer.observe(element);
      });
    }

    function initAllScienceHowItWorks() {
      document
        .querySelectorAll('[data-apex-science-how-it-works]')
        .forEach(initScienceHowItWorks);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllScienceHowItWorks);
    } else {
      initAllScienceHowItWorks();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-science-how-it-works]')
        ? event.target
        : event.target.querySelector('[data-apex-science-how-it-works]');

      if (section) initScienceHowItWorks(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-science-references-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReferences(section) {
      if (!section || section.dataset.apexScienceReferencesInitialized === 'true') return;

      section.dataset.apexScienceReferencesInitialized = 'true';

      const elements = section.querySelectorAll(
        '.asr-header, .asr-card, .asr-cta, .asr-notice'
      );

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.08,
          rootMargin: '0px 0px -35px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty('--asr-delay', Math.min(index * 70, 350) + 'ms');
        observer.observe(element);
      });
    }

    function initAllReferences() {
      document
        .querySelectorAll('[data-apex-science-references]')
        .forEach(initReferences);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllReferences);
    } else {
      initAllReferences();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-science-references]')
        ? event.target
        : event.target.querySelector('[data-apex-science-references]');

      if (section) initReferences(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-shipping-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeApexShippingDetails(section) {
      if (
        !section ||
        section.dataset.apexShippingDetailsInitialized === 'true'
      ) {
        return;
      }

      section.dataset.apexShippingDetailsInitialized = 'true';

      const revealElements = section.querySelectorAll(
        '.asd-introduction, .asd-detail-card'
      );

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (
        prefersReducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        revealElements.forEach(function (element) {
          element.classList.add('is-visible');
        });

        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -45px 0px'
        }
      );

      revealElements.forEach(function (element, index) {
        element.style.setProperty(
          '--asd-reveal-delay',
          Math.min(index * 85, 420) + 'ms'
        );

        observer.observe(element);
      });
    }

    function initializeAllApexShippingDetails() {
      document
        .querySelectorAll('[data-apex-shipping-details]')
        .forEach(initializeApexShippingDetails);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeAllApexShippingDetails
      );
    } else {
      initializeAllApexShippingDetails();
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        const section = event.target.matches(
          '[data-apex-shipping-details]'
        )
          ? event.target
          : event.target.querySelector(
              '[data-apex-shipping-details]'
            );

        if (section) {
          initializeApexShippingDetails(section);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-shipping-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeApexShippingFAQ(section) {
      if (
        !section ||
        section.dataset.apexShippingFaqInitialized === 'true'
      ) {
        return;
      }

      section.dataset.apexShippingFaqInitialized = 'true';

      const items = Array.from(
        section.querySelectorAll('[data-asf-item]')
      );

      const allowMultiple =
        section.dataset.allowMultiple === 'true';

      function closeItem(item, immediate) {
        const trigger = item.querySelector('[data-asf-trigger]');
        const answer = item.querySelector('[data-asf-answer]');

        if (!trigger || !answer) return;

        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');

        if (immediate) {
          answer.style.height = '';
          answer.hidden = true;
          return;
        }

        answer.style.height = answer.scrollHeight + 'px';

        window.requestAnimationFrame(function () {
          answer.style.height = '0px';
        });

        function handleCloseEnd(event) {
          if (
            event.propertyName !== 'height' ||
            item.classList.contains('is-open')
          ) {
            return;
          }

          answer.hidden = true;
          answer.style.height = '';
          answer.removeEventListener(
            'transitionend',
            handleCloseEnd
          );
        }

        answer.addEventListener(
          'transitionend',
          handleCloseEnd
        );
      }

      function openItem(item, immediate) {
        const trigger = item.querySelector('[data-asf-trigger]');
        const answer = item.querySelector('[data-asf-answer]');

        if (!trigger || !answer) return;

        if (!allowMultiple) {
          items.forEach(function (otherItem) {
            if (
              otherItem !== item &&
              otherItem.classList.contains('is-open')
            ) {
              closeItem(otherItem, immediate);
            }
          });
        }

        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        answer.hidden = false;

        if (immediate) {
          answer.style.height = 'auto';
          return;
        }

        answer.style.height = '0px';

        window.requestAnimationFrame(function () {
          answer.style.height = answer.scrollHeight + 'px';
        });

        function handleOpenEnd(event) {
          if (
            event.propertyName !== 'height' ||
            !item.classList.contains('is-open')
          ) {
            return;
          }

          answer.style.height = 'auto';
          answer.removeEventListener(
            'transitionend',
            handleOpenEnd
          );
        }

        answer.addEventListener(
          'transitionend',
          handleOpenEnd
        );
      }

      items.forEach(function (item) {
        const trigger = item.querySelector('[data-asf-trigger]');
        const answer = item.querySelector('[data-asf-answer]');

        if (!trigger || !answer) return;

        if (item.classList.contains('is-open')) {
          answer.hidden = false;
          answer.style.height = 'auto';
        } else {
          answer.hidden = true;
        }

        trigger.addEventListener('click', function () {
          if (item.classList.contains('is-open')) {
            closeItem(item, false);
          } else {
            openItem(item, false);
          }
        });
      });

      const revealElements = section.querySelectorAll(
        '.asf-header, .asf-item, .asf-support-card'
      );

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (
        prefersReducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        revealElements.forEach(function (element) {
          element.classList.add('is-visible');
        });
      } else {
        const observer = new IntersectionObserver(
          function (entries, currentObserver) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;

              entry.target.classList.add('is-visible');
              currentObserver.unobserve(entry.target);
            });
          },
          {
            threshold: 0.12,
            rootMargin: '0px 0px -45px 0px'
          }
        );

        revealElements.forEach(function (element, index) {
          element.style.setProperty(
            '--asf-reveal-delay',
            Math.min(index * 80, 480) + 'ms'
          );

          observer.observe(element);
        });
      }

      window.addEventListener('resize', function () {
        items.forEach(function (item) {
          if (!item.classList.contains('is-open')) return;

          const answer = item.querySelector('[data-asf-answer]');

          if (answer) {
            answer.style.height = 'auto';
          }
        });
      });
    }

    function initializeAllApexShippingFAQs() {
      document
        .querySelectorAll('[data-apex-shipping-faq]')
        .forEach(function (section) {
          section.dataset.allowMultiple =
            section.getAttribute('data-allow-multiple') || 'false';

          initializeApexShippingFAQ(section);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeAllApexShippingFAQs
      );
    } else {
      initializeAllApexShippingFAQs();
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        const section = event.target.matches(
          '[data-apex-shipping-faq]'
        )
          ? event.target
          : event.target.querySelector(
              '[data-apex-shipping-faq]'
            );

        if (section) {
          section.dataset.allowMultiple =
            section.getAttribute('data-allow-multiple') || 'false';

          initializeApexShippingFAQ(section);
        }
      }
    );

    document.addEventListener(
      'shopify:block:select',
      function (event) {
        const item = event.target.closest('[data-asf-item]');
        const section = event.target.closest(
          '[data-apex-shipping-faq]'
        );

        if (!item || !section) return;

        const trigger = item.querySelector('[data-asf-trigger]');
        const answer = item.querySelector('[data-asf-answer]');

        section
          .querySelectorAll('[data-asf-item]')
          .forEach(function (otherItem) {
            if (otherItem === item) return;

            otherItem.classList.remove('is-open');

            const otherTrigger = otherItem.querySelector(
              '[data-asf-trigger]'
            );

            const otherAnswer = otherItem.querySelector(
              '[data-asf-answer]'
            );

            if (otherTrigger) {
              otherTrigger.setAttribute(
                'aria-expanded',
                'false'
              );
            }

            if (otherAnswer) {
              otherAnswer.hidden = true;
              otherAnswer.style.height = '';
            }
          });

        item.classList.add('is-open');

        if (trigger) {
          trigger.setAttribute('aria-expanded', 'true');
        }

        if (answer) {
          answer.hidden = false;
          answer.style.height = 'auto';
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-shipping-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initializeApexShippingHero(section) {
    if (
      !section ||
      section.dataset.apexShippingHeroInitialized === 'true'
    ) {
      return;
    }

    section.dataset.apexShippingHeroInitialized = 'true';

    const revealElements = section.querySelectorAll(
      '.ash-content, .ash-media, .ash-highlight'
    );

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (
      prefersReducedMotion ||
      !('IntersectionObserver' in window)
    ) {
      revealElements.forEach(function (element) {
        element.classList.add('is-visible');
      });

      return;
    }

    const observer = new IntersectionObserver(
      function (entries, currentObserver) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    revealElements.forEach(function (element, index) {
      element.style.setProperty(
        '--ash-reveal-delay',
        Math.min(index * 80, 320) + 'ms'
      );

      observer.observe(element);
    });
  }

  function initializeAllApexShippingHeroes() {
    document
      .querySelectorAll('[data-apex-shipping-hero]')
      .forEach(initializeApexShippingHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllApexShippingHeroes
    );
  } else {
    initializeAllApexShippingHeroes();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      const section =
        event.target.matches('[data-apex-shipping-hero]')
          ? event.target
          : event.target.querySelector(
              '[data-apex-shipping-hero]'
            );

      if (section) {
        initializeApexShippingHero(section);
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-shipping-support-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeApexShippingSupportCTA(section) {
      if (
        !section ||
        section.dataset.apexShippingSupportCtaInitialized === 'true'
      ) {
        return;
      }

      section.dataset.apexShippingSupportCtaInitialized = 'true';

      const revealElements = section.querySelectorAll(
        '.assc-content, .assc-visual'
      );

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (
        prefersReducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        revealElements.forEach(function (element) {
          element.classList.add('is-visible');
        });

        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -50px 0px'
        }
      );

      revealElements.forEach(function (element, index) {
        element.style.setProperty(
          '--assc-reveal-delay',
          index * 130 + 'ms'
        );

        observer.observe(element);
      });
    }

    function initializeAllApexShippingSupportCTAs() {
      document
        .querySelectorAll('[data-apex-shipping-support-cta]')
        .forEach(initializeApexShippingSupportCTA);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeAllApexShippingSupportCTAs
      );
    } else {
      initializeAllApexShippingSupportCTAs();
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        const section = event.target.matches(
          '[data-apex-shipping-support-cta]'
        )
          ? event.target
          : event.target.querySelector(
              '[data-apex-shipping-support-cta]'
            );

        if (section) {
          initializeApexShippingSupportCTA(section);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-shipping-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initializeApexShippingTimeline(section) {
    if (
      !section ||
      section.dataset.apexShippingTimelineInitialized === 'true'
    ) {
      return;
    }

    section.dataset.apexShippingTimelineInitialized = 'true';

    const revealElements = section.querySelectorAll(
      '.ast-header, .ast-step'
    );

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (
      prefersReducedMotion ||
      !('IntersectionObserver' in window)
    ) {
      revealElements.forEach(function (element) {
        element.classList.add('is-visible');
      });

      return;
    }

    const observer = new IntersectionObserver(
      function (entries, currentObserver) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -45px 0px'
      }
    );

    revealElements.forEach(function (element, index) {
      element.style.setProperty(
        '--ast-reveal-delay',
        Math.min(index * 90, 360) + 'ms'
      );

      observer.observe(element);
    });
  }

  function initializeAllApexShippingTimelines() {
    document
      .querySelectorAll('[data-apex-shipping-timeline]')
      .forEach(initializeApexShippingTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllApexShippingTimelines
    );
  } else {
    initializeAllApexShippingTimelines();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      const section =
        event.target.matches('[data-apex-shipping-timeline]')
          ? event.target
          : event.target.querySelector(
              '[data-apex-shipping-timeline]'
            );

      if (section) {
        initializeApexShippingTimeline(section);
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-terms-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initApexTermsHero(section) {
      if (!section || section.dataset.apexTermsHeroInitialized === 'true') return;

      section.dataset.apexTermsHeroInitialized = 'true';

      const elements = section.querySelectorAll('.ath-copy, .ath-panel');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.14,
          rootMargin: '0px 0px -40px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty('--ath-delay', (index * 130) + 'ms');
        observer.observe(element);
      });
    }

    function initAllApexTermsHero() {
      document
        .querySelectorAll('[data-apex-terms-hero]')
        .forEach(initApexTermsHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllApexTermsHero);
    } else {
      initAllApexTermsHero();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-terms-hero]')
        ? event.target
        : event.target.querySelector('[data-apex-terms-hero]');

      if (section) initApexTermsHero(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-why-choose-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initWhyChooseHero(section) {
      if (!section || section.dataset.apexWhyChooseHeroInitialized === 'true') return;

      section.dataset.apexWhyChooseHeroInitialized = 'true';

      const elements = section.querySelectorAll('.awch-copy, .awch-media-wrap');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.08,
          rootMargin: '0px 0px -35px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty('--awch-delay', index * 110 + 'ms');
        observer.observe(element);
      });
    }

    function initAllWhyChooseHeroes() {
      document
        .querySelectorAll('[data-apex-why-choose-hero]')
        .forEach(initWhyChooseHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllWhyChooseHeroes);
    } else {
      initAllWhyChooseHeroes();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-why-choose-hero]')
        ? event.target
        : event.target.querySelector('[data-apex-why-choose-hero]');

      if (section) initWhyChooseHero(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-why-wellness-product-design"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initWhyWellness(section) {
      if (!section || section.dataset.apexWhyWellnessInitialized === 'true') return;

      section.dataset.apexWhyWellnessInitialized = 'true';

      const elements = section.querySelectorAll(
        '.aww-header, .aww-media, .aww-feature, .aww-statement'
      );

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries, currentObserver) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.08,
          rootMargin: '0px 0px -35px 0px'
        }
      );

      elements.forEach(function (element, index) {
        element.style.setProperty('--aww-delay', Math.min(index * 70, 350) + 'ms');
        observer.observe(element);
      });
    }

    function initAllWhyWellness() {
      document
        .querySelectorAll('[data-apex-why-wellness]')
        .forEach(initWhyWellness);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllWhyWellness);
    } else {
      initAllWhyWellness();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const section = event.target.matches('[data-apex-why-wellness]')
        ? event.target
        : event.target.querySelector('[data-apex-why-wellness]');

      if (section) initWhyWellness(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
